<template>
    <v-dialog max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" v-model="show" persistent >
      <v-card class="rounded-card">
        <v-system-bar color="teal" height="60px">
           <span class="headline font-weight-bold ms-2"> {{title}}</span>
        </v-system-bar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs8 sm6>
              <v-text-field v-if="isNewFeed" :label="$t('Feed Code')" v-model="feed.code"></v-text-field>
              <v-text-field v-else :label="$t('Feed Code')" v-model="feed.code" readonly color="grey"></v-text-field>
            </v-flex>
            <v-flex v-if="$vuetify.breakpoint.smAndUp" sm2 ></v-flex>
            <v-flex xs4 sm4>
              <v-switch v-model="feed.active" :label="$t('Active')" color="primary" class="ps-3" ></v-switch>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <v-text-field :label="$t('Feed Name')" v-model="feed.name"></v-text-field>
          </v-flex>
          <v-layout wrap>
          <v-flex xs11 sm7>
            <v-select flat class="pe-1" :items="dropdown_feed_type" v-model="feed.feedType"
                :label="$t('Feed Type')" editable item-value="value">
            </v-select>
          </v-flex>
            <v-layout column align-sm-end>
            <v-flex xs12 sm5>
                <v-switch v-model="feed.manLoad" :label="$t('Manual Load')" color="primary"></v-switch>
            </v-flex>
            </v-layout>
          </v-layout>
          <v-layout wrap>
            <v-flex xs8 sm4>
              <v-text-field class="me-3" :label="$t('Load Tolerance')" v-model.number="feed.tolerance" :hint="$t('Loading tolerance in Kg')"></v-text-field>
            </v-flex>
            <!-- <v-flex xs1></v-flex> -->
            <v-flex xs8 sm4>
              <v-text-field  class="ms-1 me-3" :label="$t('Feed Value')" v-model.number="feed.value" :hint="$t('Price per') + ' '+ unit"></v-text-field>
            </v-flex>
            <!-- <v-flex xs1></v-flex> -->
            <v-flex xs8 sm4>
              <v-text-field class="ms-1" :label="$t('Dry Material')+' %'" v-model.number="feed.dryMaterial"></v-text-field>
            </v-flex>
          </v-layout>
           <v-layout wrap v-if="!isNewFeed">
            <v-flex xs8 sm8>
              <v-text-field class="ms-1 me-3" :label="$t('Inventory Level')" readonly :value="feed.invQty | kgString"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-tooltip bottom>
                <template v-slot:activator="{on}">
                  <v-btn icon large color="primary" v-on="on" class="ms-10 mt-2"
                    @click="zeroInventory">
                    <v-icon>mdi-numeric-0-box</v-icon> {{$t('Zero')}}
                  </v-btn>
                </template>
                <span>{{$t('Reset Inventory Quantity')}}</span>
              </v-tooltip>
            </v-flex>
           </v-layout>

        </v-card-text>
        <v-card-actions>
          <v-tooltip top v-if="feed_id">
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="DeleteFeed">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Delete Feed') + " " + feed.name}}</span>
          </v-tooltip>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" class="mx-2"
                @click="showDelivery=true">
                <v-icon>mdi-truck-delivery</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Accept Feed Delivery')}}</span>
          </v-tooltip>
          <BuyFeedDialog v-model="showDelivery" v-bind:feedId="feedId" v-on:close="showDelivery=false" v-bind:show="true" />
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon color="primary" v-on="on" @click.stop="CancelDialog" class="mx-2">
                <v-icon>mdi-cancel</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Cancel') + " "+ $t('exit without saving')}}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{on}">
              <v-btn icon large color="primary" v-on="on" @click.stop="SaveFeed" class="mx-2">
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </template>
            <span>{{$t('Save Feed')}}</span>
          </v-tooltip>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import _ from "lodash";
import BuyFeedDialog from "@/components/BuyFeed";
export default {
    name:
        "AddEditFeedDialog",
    props: {
        value: Boolean,
        feedId: String
    },
    components: {
      BuyFeedDialog
    },
    data() {
    return {
      dropdown_feed_type: [
        { text: this.$i18n.t('Unspecified') , value: '' },
        { text: this.$i18n.t('Premix'), value: 'Premix'},
        { text: this.$i18n.t('Silage'), value: 'Silage'},
        { text: this.$i18n.t('Roughage'), value: 'Roughage'},
        { text: this.$i18n.t('Cereal grains'), value: 'Cereal grains'},
        { text: this.$i18n.t('Cereal byproducts'), value: 'Cereal byproducts'},
        { text: this.$i18n.t('Legumes and oilseeds'), value:'Legumes and oilseeds'},
        { text: this.$i18n.t('Oil byproducts'), value: 'Oil byproducts'},
        { text: this.$i18n.t('Roots and byproducts'), value:'Roots and byproducts'},
        { text: this.$i18n.t('Fruits and byproducts'), value:'Fruits and byproducts'},
        { text: this.$i18n.t('Other plant products'), value:'Other plant products'},
        { text: this.$i18n.t('Animal products'), value: 'Animal products'},
        { text: this.$i18n.t('Dairy products'), value: 'Dairy products'},
        { text: this.$i18n.t('Oils and fats'), value: 'Oils and fats'},
        { text: this.$i18n.t('Mineral products'), value: 'Mineral products'},
        { text: this.$i18n.t('Amino acids'), value: 'Amino acids'}
      ],
      feed_id: this.feedId,
      feed: {},
      showDelivery: false
    };
  },
  computed: {
    show: {
        get () {
            return this.value
        },
        set (value) {
            this.$emit("input", value);
            //this.value = value;
        }
    },
    title() {
      return this.isNewFeed ? this.$i18n.t('New Feed') : this.$i18n.t('Edit Feed')+ " "+ this.feed.code + " - " + this.feed.name
    },
    unit() {
      return this.$store.getters.getWeightUnit;
    },
    currencySymbol() {
      return this.$store.getters.getProfile.currencySymbol;
    },
    isNewFeed() {
      return !(this.feed && this.feed.Id);
    },
  },
methods: {
    zeroInventory() {
      const showMsg = this.feed.invQty != 0;
      this.feed.invQty = 0;
      if (showMsg)
        this.$root.$globalSnackbar(this.$i18n.t('Inventory level set to 0'), "warning")
    },
    CancelDialog() {
      this.feed = _.cloneDeep(this.$store.getters.getFeed(this.feed_id));
      this.show = false;
      this.$emit("close");
    },
    SaveFeed() {
      if (this.feed.dryMaterial > 1)
        this.feed.dryMaterial /= 100;
      this.feed.translatedFeedType = this.$i18n.t(this.feed.feedType);
      var payload = {Id: this.feed_id, ...this.feed}
      this.$store.dispatch("saveFeed", payload);
      this.show=false;
      this.$emit("close");
    },
    DeleteFeed() {
      if (this.feed_id) {
        this.$root.$confirm(this.$i18n.t('Delete'), this.$i18n.t('Delete Feed') + " "+ this.feed.name + "?", { color: "red" }).then((confirm) => {
          if (confirm) {
            this.$store.dispatch("deleteFeed", this.feed_id);
            this.show=false;
            this.$emit("close");
          }
        });
      }
    },
  },
  created() {
      return this.feed = _.cloneDeep(this.$store.getters.getFeed(this.feed_id));
  },
  mounted: function () {
    document.addEventListener("keydown", (e) => {
        if (this.show && e.keyCode == 27) {
          if (this.feed_id)
            this.feed = _.cloneDeep(this.$store.getters.getFeed(this.feed_id));
          this.$emit("close");
          this.show=false;
        }
      });
    },
}
</script>

